import {
  CallOutCoverageData,
  CallOutCoverageQueryParams,
  ShiftsResponse as Response,
  convertCallOutCoverage,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCallOutCoverage(
  params: CallOutCoverageQueryParams,
  enabled = true
) {
  const { server } = useServer()
  return useQuery<CallOutCoverageData>({
    queryKey: keys.callout(params),
    queryFn: fetchCallOutCoverage,
    enabled: enabled && !!params.uri,
  })

  async function fetchCallOutCoverage() {
    return convertCallOutCoverage(
      await server.get<Response.CallOutCoverageData>(getUrl(params))
    )
  }
}

function getUrl(params: CallOutCoverageQueryParams): string {
  const url = decodeURIComponent(params.uri)
  return url
}
